module.exports = __webpack_public_path__ + "static/media/biblioteket.00c7e72a.mp3";